import React from 'react';
import { Link } from 'react-router-dom';

const ButtonSectionMaster = ({link, text}) => (
    <section className="container-link-blog">
        <Link to={link} >{text}</Link>
    </section>
)

export default ButtonSectionMaster;
